import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { ApiGetGenreCategories } from '../../actions/Api';
import Grid from '../../components/Grid/Grid';
import GenreCategoryGridItem from '../../components/GridItem/GenreCategoryGridItem';
import {
  BrowseGenresKeys,
  BrowseGenresMessages,
  MyStationsGenreCategoryTokens,
} from '../../constants/BrowseGenres';

import './MyStationsGenreCategories.scss';

class MyStationsGenreCategories extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    ApiGetGenreCategories: PropTypes.func.isRequired,
    genreCategoriesHaveLoaded: PropTypes.bool,
  };

  componentWillMount() {
    if (!this.props.genreCategoriesHaveLoaded) {
      this.props.ApiGetGenreCategories();
    }
  }

  getTitle = () => {
    return this.props.intl.formatMessage(BrowseGenresMessages.browseGenreCategoriesTitle);
  };

  generateGridItems = () => {
    if (!this.props.genreCategoriesHaveLoaded) {
      return [];
    }

    return MyStationsGenreCategoryTokens.map((genreCategoryToken, i) => {
      return (
        <GenreCategoryGridItem
          key={i}
          genreCategoryToken={genreCategoryToken}
          showListenerCount={true}
        />
      );
    });
  };

  render() {
    return (
      <div className='MyStationsGenreCategories'>
        <div className='MyStationsGenreCategories__gridContainer'>
          <Grid items={this.generateGridItems()} isLoaded={this.props.genreCategoriesHaveLoaded}>
            <div className='MyStationsGenreCategories__header'>{this.getTitle()}</div>
          </Grid>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    genreCategoriesHaveLoaded: state.browseGenres.get(
      BrowseGenresKeys.GENRE_CATEGORIES_HAVE_LOADED,
    ),
  };
}

export default connect(mapStateToProps, { ApiGetGenreCategories })(
  injectIntl(MyStationsGenreCategories),
);
